import { FAQ } from "../data-types/data-types";

export const faqs: FAQ[] = [
	{
		id: 1,
		question: "Are your programs for teens only?",
		answer: "Primarily, yes! We focus on teenagers (13 – 19 years old), but we’ve had preteens (9-12 years old) and university graduates (20-23 years old) join our programs successfully.",
	},
	{
		id: 2,
		question: "Do you guarantee results from your programs? ",
		answer: "Yes! You normally start seeing changes by the 3rd and 4th sessions. We guarantee results if your teens follow our action steps, open themselves fully to their coaching and dedicate enough time and effort. Otherwise, we guarantee a 100% refund of your investment if by the end of the program you don’t see changes.",
	},
	{
		id: 4,
		question: "How many sessions does each coaching program have?",
		answer: "Each coaching program runs for 8 weeks. During those 8 weeks, your teen will have access to 8 comprehensive coaching sessions, 8 focused and engaging HomeWorks and activities, 8 weeks accountability follow-up, 8 weeks access to SMARTA Mentorship Program, 8 weeks access to SMARTA Book Club, 1 printable workbook (pdf) and 1 SMARTA Teens Journal.",
	},
	{
		id: 3,
		question: "Do you guarantee privacy of information shared with you?",
		answer: "Absolutely! Our platform is managed by security-conscious tech professionals. No other person will be able to access your data without your permission.",
	},
	{
		id: 5,
		question: "How long is each of your coaching sessions?",
		answer: "Each coaching session strictly lasts for 1 hour. If your teen comes late to a session, the session will still end as at when due as already agreed when creating your schedule.",
	},
	{
		id: 6,
		question: "What if my teen misses a session?",
		answer: "We understand that life happens, and your teen might miss a session due to unforeseen situations. If your teen misses a session, there is an opportunity to reschedule a makeup session within the next 1 week, otherwise the investment for that session will be forfeited. But if they miss a Book club meeting, our meetings are recorded, and your teen will have access to replays.",
	},
	{
		id: 8,
		question: "Can parents attend sessions with their teen?",
		answer: "No. Except when we request for your presence, we always want teens to be comfortable, free to express themselves and trust us with every information that can help us achieve our goals. Regardless, there are special update sessions with parents when we get to discuss your teen’s progress, recommendations and answer more of your questions. Also, parents have access to a short course on parenting teens, and a 24-hour access to their teen’s progress report on their portal on SMARTA platform.",
	},
	{
		id: 7,
		question: "Does my teen have to join with camera on?",
		answer: "Yes. We require this to be able to actively monitor your teenager’s activities, and ensure they are actively available during the session. So, please, create a quiet and conducive space for them during sessions.",
	},
	{
		id: 9,
		question: "Do you coach groups or one-on-one?",
		answer: "Except for our book club, all our coaching sessions are individual-focused, and are thus conducted in one-on-one formats to ensure privacy and commitment.",
	},
	{
		id: 10,
		question: "When can I register my teen?",
		answer: "Now! What are you still waiting for? Please, note that although your teen can join anytime during the year, our mentorship program and book club run a 12 - months calendar.They start officially on January 1 and end on December 31.",
	},
	{
		id: 11,
		question: "Do you have payment plan options?",
		answer: "Yes. Please, contact us on +2348027411687 (WhatsApp).Thank you.",
	},
]